import { newPersionList, savePension, demandChart, rateList, costList, supplyChart } from '@/api/newPersion'

import { CommonMudule } from '@/store/modules/common'
import { NewPersionMap } from '@/types/newPersion'

export const customerId = CommonMudule.customerId

const customerIdObj = { customerId }

/**
 * 获取退休规划完整列表接口
 */
export const getNewPersionList = async () => (await newPersionList(customerIdObj)).data

/**
 * 更新保存退休规划接口
 */

export const saveNewPersion = async (data: NewPersionMap) => (await savePension({ ...data, ...customerIdObj })).data

/**
 * 退休规划需求图分析
 */
export const getDemandChart = async () => (await demandChart(customerIdObj)).data

/**
 * 退休规划供给分析图
 */
export const getSupplyChart = async () => (await supplyChart(customerIdObj)).data

/**
 * 获取通货膨胀率接口
 */
export const getRateList = async () => (await rateList()).data

/**
 * 获取城市等级对应养老费用列表
 */
export const getCostList = async () => (await costList()).data
